import React from 'react';

export default function MdxRow({ children }) {
	return <div className="flex items-center flex-wrap pb-10 last:pb-0">{children}</div>;
}
